import { Prices } from '@uds/prices';
import { useMarket } from '@ux/whitelabel';

export type PricingStrategy = 'MONTHLY' | 'YEARLY';

const priceMap: Record<PricingStrategy, number> = {
  MONTHLY: 12,
  YEARLY: 1,
};

export const calculateIntervalPrice = (amount: number, pricingStrategy: PricingStrategy) => {
  return amount / priceMap[pricingStrategy];
};

type Props = {
  amount: number;
  currency: string;
  pricingStrategy?: PricingStrategy;
};

export default function Price({ amount, currency, pricingStrategy = 'YEARLY' }: Readonly<Props>): JSX.Element {
  const market = useMarket();
  const intervalPrice = calculateIntervalPrice(amount, pricingStrategy);

  return <Prices amount={intervalPrice} currency={currency} market={market} />;
}
